/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ApplyIdModule } from './apply-id.module';
export { ApplyIdComponent } from './apply-id.component';